import React, { useState, useEffect, Component, Fragment, useContext } from "react";
import {
   Collapse,
   Nav,
   NavItem,
   Modal,
   Navbar,
   Dropdown,
   NavbarToggler, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, ModalBody
} from "reactstrap";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";

import darktheme from '../assets/images/darktheam-logo.png';


import moblogoDarktheme from '../assets/images/ICON.png';


import NoThemeImg from '../assets/images/NO brackground.png';



import casino from '../assets/images/casino.png';
import sports from '../assets/images/sports.png';

import lgroc from '../assets/images/lg_roc.png';
import circle from '../assets/images/close-circle.png';
import lgkan from '../assets/images/lg_kannuicon.svg';
import lggr1 from '../assets/images/lg_gr_1.svg';



import liveCasinoImg from '../assets/images/menu-icons/livecasino.svg';

import casinonew from '../assets/images/original.png';



import { Notify } from "notiflix/build/notiflix-notify-aio";
import { verifyTfa } from "../Features/TfaSettings/tfaSettingslice";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { addNewUser, login, logout } from "../Features/Register/registerSlice";
import {
   forgetPassword,
   resetPassword,
} from "../Features/Password/passwordSlice";

import { set, useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useCustomizeContext } from "../context";
import { NumericFormat } from "react-number-format";
import { getUserDetails } from "../Features/SiteSettings/siteSettingSlice";
import { useNavigate } from "react-router";
import { getWalletBalance } from "../Features/WalletDetails/walletBalanceSlice";
import { GoogleLogin } from "react-google-login";

import { PatternFormat } from "react-number-format";
import ReCAPTCHA from "react-google-recaptcha";


import {
   googleLogin,
   appleLogin,
   faceBookLogin,
} from "../Features/SocialLogin/socialLoginSlice";
import helper from "../Helper";

import { gapi } from "gapi-script";
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { SkeletonTheme } from 'react-loading-skeleton';
import { useTranslation, I18nextProvider } from "react-i18next";
import { SocketContext } from "../context/socket";
import brazilFlag from "../../src/assets/images/brazil.png";
import usFlag from "../../src/assets/images/united-states-of-america.png";

import Search from "../views/SearchComponent";
import { getSearchGames } from "../../src/Features/GameCommon/gameCommonSlice";
import 'react-phone-input-2/lib/style.css'

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';




const Header = (props) => {

   const { t, i18n } = useTranslation();

   const socket = useContext(SocketContext);


   //  Google Recaptcha 

   const [farmCaptcha, setFarmCaptcha] = useState("");
   const [farmErrCaptcha, setFarmErrCaptcha] = useState("");


   const {
      loader: { loading, setLoading },
      modelStatus: {
         modal,
         setModal,
         modal1,
         setModal1,
         modal2,
         setModal2,
         modal3,
         setModal3,
         modal4,
         setModal4,
      },
      userAuthToken: { userToken, setUserToken },
      forget: { forgetCode },
      siteInformation: { favicon, logo, darkThemeLogo },
      bet: { selectedCurrency, setSelectedCurrency, balance, setBalance, selectCurrency, setSelectCurrency },
      apiResponses: {
         updateRes,
      },
      mineGameMode: {
         mineMode, setMineMode,
      },
      theme: {
         lightThemeIsActive, setLightThemeIsActive
      },
      userInfo: {
         userName, setUserName,
         profile, setProfile,
      },
      languageContext: {
         language, setLanguage,
         changeLanguageRes, setChangeLanguageRes,
         languageType, setLanguageType,
      },
      categoryMode: {
         isActive, setIsActive
      },
      sideMenu: {
         classIsActive, setClassIsActive
      },
      gameSearch: {
         searchGameRes, setGameSearchRes,
         searchIsActive, setSearchIsActive,
         searchText, setSearchText,
      }
   } = useCustomizeContext();

   let navigate = useNavigate();

   let googleId = helper.GoogleClientID();
   let facebookId = helper.FaceBoolClientID();

   const withdrawres = useSelector((state) => state?.bankdata?.AddWithdrawres)

   const depositres = useSelector((state) => state?.bankdata?.AddDepositres)

   const [tfaCode, setTfacode] = useState("");
   const [id, setId] = useState("");

   const [passwordType, setPasswordType] = useState("password");
   const [confirmpasswordType, setConfirmPasswordType] = useState("password");



   const [walletBalanceRes, setWalletBalanceRes] = useState([]);


   const [cpfNumber, setCpfNumber] = useState("");

   const [dateOfBirth, setDateOfBirth] = useState(new Date());

   // Functions

   useEffect(() => {
      setUserToken(localStorage.getItem("loginToken"));
   }, [userToken]);


   const SignupSchema = yup.object().shape({
      username: yup
         .string()
         .required(`${t('Username is required')} !`)
         .min(3, `${t('Username must be  3 characters long')} !`),
      fullName: yup
         .string()
         .required(`${t('Name is required')} !`)
         .min(3, `${t('Name Must be  3 Characters long')} !`),
      email_address: yup
         .string()
         .email(`${t('Invalid Email')} !`)
         .required(`${t('Email is required')}!`),
      password: yup
         .string()
         .required(`${t('Password is required')} !`)
         .matches(/^\S.*[a-zA-Z\s]*$/, `${t('First Character Whitespace Not Allowed')} !`),
      confirm_password: yup
         .string()
         .required(`${t('Confirm password is required')} !`)
         .oneOf(
            [yup.ref("password")],
            `${t('Password Confirm Password does not match')} !`
         ),
      phoneNumber: yup
         .string().required(`${t('Phone Number is Required')} !`)
         .matches(/(\d{2})(\d{1})(\d{4})(\d{4})/, `${t('Invalid Phone Number')} !`),
      terms: yup.boolean().oneOf([true], `${t('Must Accept Terms and Conditions')}  !`),
   });

   const {
      register,
      handleSubmit,
      watch,
      reset,
      clearErrors,
      control,
      formState: { errors },
   } = useForm({
      resolver: yupResolver(SignupSchema),
      mode: "onBlur",
   });

   const SignInSchema = yup.object().shape({
      email: yup
         .string()
         .email(`${t('Invalid Email')} !`)
         .required(`${t('Email is required')} !`),
      password: yup.string().required(`${t('Password is required')} !`)
         .matches(/^\S.*[a-zA-Z\s]*$/, `${t('First Character Whitespace Not Allowed')} !`),
   });

   const {
      register: register1,
      handleSubmit: handleSubmit1,
      watch: watch1,
      reset: reset1,
      clearErrors: clearErrors1,
      formState: { errors: errors1 },
   } = useForm({
      resolver: yupResolver(SignInSchema),
      mode: "onBlur",
   });

   const ForgetSchema = yup.object().shape({
      email: yup
         .string()
         .email(`${t('Invalid Email')} !`)
         .required(`${t('Email is required')} !`),
   });

   const {
      register: register2,
      handleSubmit: handleSubmit2,
      watch: watch2,
      reset: reset2,
      clearErrors: clearErrors2,
      formState: { errors: errors2 },
   } = useForm({
      resolver: yupResolver(ForgetSchema),
      mode: "onBlur",
   });

   const ResetPasswordSchema = yup.object().shape({
      password: yup
         .string()
         .required(`${t('Password is required')} !`)
         .matches(/^\S.*[a-zA-Z\s]*$/, `${t('First Character Whitespace Not Allowed')} !`),
      confirm_password: yup
         .string()
         .required(`${t('Confirm password is required')} !`)
         .oneOf(
            [yup.ref("password")],
            `${t('Password Confirm Password does not match')} !`
         ),
   });

   const {
      register: register3,
      handleSubmit: handleSubmit3,
      watch: watch3,
      reset: reset3,
      clearErrors: clearErrors3,
      formState: { errors: errors3 },
   } = useForm({
      resolver: yupResolver(ResetPasswordSchema),
      mode: "onBlur",
   });


   const sideMenu = () => {
      setClassIsActive(!classIsActive);
      !classIsActive
         ? document.body.classList.add("SideMenuOpen")
         : document.body.classList.remove("SideMenuOpen");
   };

   useEffect(() => {
      if (userToken) {
         getBalance();
         getuserProfile();
      }
   }, [userToken, updateRes, withdrawres, depositres]);

   const getBalance = async () => {
      if (mineMode === "manual") {
         setLoading(true);
      }
      let res = await dispatch(getWalletBalance());
      setTimeout(() => {
         if (res?.status === true) {
            setWalletBalanceRes(res?.data);
            setSelectedCurrency(res?.data);

            if (selectCurrency) {
               res?.data?.map((temp) => {
                  if (temp?.symbol === selectCurrency?.symbol) {
                     setSelectCurrency(temp);
                     setBalance(temp?.originalBal?.toFixed(2));
                  }
               })
            }
            else {
               let jsonStr = JSON.stringify([res?.data[0]]);
               localStorage.setItem("currency", jsonStr);
               setSelectCurrency(res?.data[0]);
               setBalance(res?.data[0]?.originalBal?.toFixed(2));
            }
            setLoading(false);
         } else {
            setLoading(false);
         }
      }, 500);
   };



   const getuserProfile = async () => {
      if (mineMode === "manual") {
         setLoading(true);
      }
      let res = await dispatch(getUserDetails());
      setTimeout(() => {
         if (res?.status) {
            setProfile(res?.data?.details?.profile_picture);

            setUserName(res?.data?.details?.username);
            setLoading(false);
         } else {
            setLoading(false);
         }
      }, 500);
   };

   const togglePopLogin = () => {
      setModal(!modal);
      setModal1(false);
      setModal2(false);
      setModal3(false);
      setModal4(false);
      reset1();
   };

   const togglePopReset = () => {
      setModal3(!modal3);
      setModal1(false);
      setModal2(false);
      setModal(false);
      setModal4(false);
      reset3();
   };

   const togglePopForgot = () => {
      setModal1(!modal1);
      setModal(false);
      setModal2(false);
      setModal3(false);
      setModal4(false);
      reset2();
   };

   const togglePopRegister = () => {
      setModal2(!modal2);
      setModal1(false);
      setModal(false);
      setModal3(false);
      setModal4(false);
      reset();
   };

   let dispatch = useDispatch();


   const SocketLoginListen = () => {
      socket.on("userlogin", function (Data) {
         if (Data?.status === true) {
            localStorage.setItem("loginToken", Data?.data?.login_id);
            sessionStorage.setItem("isActive", true);
            setUserToken(Data?.data?.login_id);
            afterLogin();
            navigate('/deposit')
         }
         else {

         }
      })
   }

   const [cpfFocus, setCpfFocus] = useState(false)

   const onSubmit = async (data) => {
      if (farmCaptcha && cpfNumber) {
         setCpfFocus(false);
         setLoading(true);
         let changeCPF = cpfNumber?.replaceAll('.', '').replaceAll('-', '');
         data = Object.assign(data, { 'CPF': changeCPF })
         let res = await dispatch(addNewUser(data));
         if (res?.status === true) {
            let emitData = {
               'email': data?.email_address,
               'password': data?.confirm_password,
            };
            socket.emit("regUserMail", emitData);
            SocketLoginListen();
            setTimeout(() => {
               setModal2(!modal2);
               setLoading(false);
               reset();
               setDateOfBirth("")
            }, 500);
         } else {
            setTimeout(() => {
               setLoading(false);
               reset();
               setDateOfBirth("")
            }, 500);
         }
      }
      else if (cpfNumber === "" || cpfNumber === null || cpfNumber === undefined) {
         setCpfFocus(true);
         Notify.failure(`${t('CPF is Required')} !`, {
            theme: "colored",
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
            position: "center-top"
         });
      }
      else {
         Notify.failure(`${t('Google Captcha is Required')} !`, {
            theme: "colored",
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
            position: "center-top"
         });
      }
   };




   const onSubmit1 = async (data) => {
      setLoading(true);
      let res = await dispatch(login(data));
      if (res?.status === true && res?.tfa === "enable") {
         setTimeout(() => {
            setLoading(false);
            setId(res?._id);
            setModal4(!modal4);
            setModal(!modal);
            afterLogin();
         }, 500);
      } else if (res?.status === true && res?.tfa === "disable") {
         setTimeout(async () => {
            localStorage.setItem("loginToken", res?.data?.login_id);
            sessionStorage.setItem("isActive", true);
            setUserToken(res?.data?.login_id);
            setModal(!modal);
            setLoading(false);
            reset1();
            getBalance();
            afterLogin();
         }, 500);
      } else {
         setTimeout(() => {
            setLoading(false);
            reset1();
         }, 500);
      }
   };


   useEffect(() => {
      if (userToken) {
         afterLogin();
      }
   }, [userToken])


   //  After Login

   const afterLogin = () => {
      document.body.classList.add("afterLoginMenu")
   }


   const logoutUser = async () => {
      setLoading(true);
      let res = await dispatch(logout());
      setLoading(true);
      setTimeout(() => {
         if (res?.status) {
            localStorage.removeItem("loginToken");
            localStorage.removeItem("currency");
            sessionStorage.removeItem("isActive");
            setUserToken("");
            setUserName("");
            navigate("/");
            setLoading(false);
         } else {
            setLoading(false);
         }
      }, 500);
   };

   const onSubmit2 = async (data) => {
      setLoading(true);
      let res = await dispatch(forgetPassword(data));
      if (res?.status === true) {
         setTimeout(() => {
            setModal1(!modal1);
            setLoading(false);
            reset2();
         }, 500);
      } else {
         setTimeout(() => {
            setLoading(false);
            reset2();
         }, 500);
      }
   };


   const onSubmit3 = async (data) => {
      setLoading(true);
      let post = {
         forgot_code: forgetCode,
         password: data?.password,
         confirm_password: data?.confirm_password,
      };
      let res = await dispatch(resetPassword(post));
      if (res?.status === true) {
         setTimeout(() => {
            setModal3(!modal3);
            setLoading(false);
            reset3();
         }, 500);
      } else {
         setTimeout(() => {
            setLoading(false);
            reset3();
         }, 500);
      }
   };

   useEffect(() => {
      function start() {
         gapi.client.init({
            clientId: googleId,
            scope: "",
         });
      }

      gapi.load("client:auth2", start);
   }, []);

   const tfaValidate = async (e) => {
      e.preventDefault();
      if (tfaCode !== "") {
         setLoading(true);
         let data = {
            tfa_code: tfaCode,
            _id: id,
         };
         let res = await dispatch(verifyTfa(data));
         if (res?.status === true) {
            setTimeout(() => {
               localStorage.setItem("loginToken", res?.data?.token);
               setUserToken(res?.data?.token);
               setModal4(!modal4);
               setLoading(false);
               setTfacode("");
               getBalance();

            }, 500);
         } else {
            setTimeout(() => {
               setTfacode("");
               setLoading(false);
            }, 500);
         }
      } else {
         Notify.failure(`${t('TFA code is Required')} !!!`, {
            theme: "colored",
            showOnlyTheLastOne: true,
            clickToClose: true,
            timeout: 1500,
         });
      }
   };



   const showVisibilitypwd = (e) => {
      e.preventDefault();
      if (passwordType === "password") setPasswordType("text");
      else setPasswordType("password");
   };

   const showVisibilitycpwd = (e) => {
      e.preventDefault();
      if (confirmpasswordType === "password") setConfirmPasswordType("text");
      else setConfirmPasswordType("password");
   };

   const responseGoogle = async (response) => {
      setLoading(true);
      const googledata = {
         address: response?.profileObj?.email,
         type: "google",
      };
      let res = await dispatch(googleLogin(googledata));
      setTimeout(() => {
         if (res?.status === true) {
            localStorage.setItem("loginToken", res?.data?.login_id);
            setUserToken(res?.data?.login_id);
            setModal(!modal);
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 500);


   };

   const responseGooglefailure = (response) => {
      if (response.error === "popup_closed_by_user") {
         Notify.failure("Closed by user !!!", { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 })
      }
      else {
         Notify.failure(response?.error, { showOnlyTheLastOne: true, clickToClose: true, timeout: 1500 })
      }

   };




   useEffect(() => {
      let find = JSON.parse(localStorage.getItem("currency"));
      if (find?.length > 0) {
         setSelectCurrency(find[0]);
         setBalance(+find[0].originalBal?.toFixed(2));
      }
   }, []);

   const getCurrency = (id) => {
      if (id) {
         let find = selectedCurrency?.filter((temp) => temp?.cid === id);
         let setItem = JSON.stringify(find)
         localStorage.setItem("currency", setItem);
         setSelectCurrency(find[0]);
         setBalance(+find[0].originalBal?.toFixed(2));
      }
   }



   const languageLists = [
      {
         name: "Portuguese BR",
         icon: "🇧🇷",
         url: brazilFlag,
         value: "pt"
      },
      {
         name: "English",
         icon: "🇺🇸",
         url: usFlag,
         value: "en"
      },
   ]



   const [dropdownOpen, setdropdownOpen] = useState(false);
   const [langDrop, setlangDrop] = useState("🇺🇸");
   const [flagUrl, setFlagUrl] = useState("");
   const toggleDrop = () => setdropdownOpen(!dropdownOpen);



   useEffect(() => {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
         setLanguage(languageLists[1]);
         setlangDrop(languageLists[1]?.icon);
         setFlagUrl(languageLists[1]?.url);
         localStorage.setItem("lang", languageLists[1]?.value);
         setLanguageType(languageLists[1]?.value);
         i18n.changeLanguage(languageLists[1]?.value);
         localStorage.setItem("i18nextLng", languageLists[1]?.value)
      }
      else {
         setLanguage(languageLists[0]);
         setlangDrop(languageLists[0]?.icon);
         setFlagUrl(languageLists[0]?.url);
         localStorage.setItem("lang", languageLists[0]?.value);
         setLanguageType(languageLists[0]?.value);
         i18n.changeLanguage(languageLists[0]?.value);
         localStorage.setItem("i18nextLng", languageLists[0]?.value)
      }
   }, []);

   const selectLanguage = (data) => {
      setlangDrop(data.icon);
      setFlagUrl(data?.url);
      setLanguage(data);
      i18n.changeLanguage(data?.value);
      localStorage.setItem("lang", data?.value);
      setLanguageType(data?.value);
      setChangeLanguageRes(!changeLanguageRes);
   }

   const ClearErrors = () => {
      clearErrors();
      clearErrors1();
      clearErrors2();
      clearErrors3();
   }

   useEffect(() => {
      ClearErrors();
   }, [changeLanguageRes]);


   //  Get All Games Search Function

   useEffect(() => {
      let data = {
         gamename: ""
      }
      searchGame(data);
   }, []);


   const getSearchFunction = async (event) => {
      setSearchText(event.target.value);
      if (event.target.value?.length >= 3) {
         let data = {
            gamename: event?.target?.value
         }
         searchGame(data);
      }
      else if (event.target.value === "") {
         let data = {
            gamename: event?.target?.value
         }
         searchGame(data);
      }
   }

   const searchGame = async (data) => {
      let gameRes = await dispatch(getSearchGames(data));
      if (gameRes?.status) {
         setGameSearchRes(gameRes?.data);
      }
      else {
         setGameSearchRes([]);
      }
   }


   const clearSearch = async () => {
      setSearchIsActive(false);
      setSearchText("");
      let data = {
         gamename: ""
      }
      searchGame(data);
   }





   return (
      <Fragment>
         <header className="">
            <div className="header-maincnt">
               {
                  searchIsActive ?
                     <Search />
                     :
                     null
               }
               <div className="header-gridmain">
                  <div className="headerlogo-cnt">
                     <Link to="/">
                        <div className="">
                           <img src={darktheme} alt="" className="img-fluid fulllogo" />
                           <img src={moblogoDarktheme} alt="" width="50" className="img-fluid halflogo" />
                        </div>
                     </Link>
                     <button className="headermenu-btn newsvgmenu d-none d-md-block" onClick={sideMenu}>


                        <svg
                           viewBox="0 0 36 34"
                           id="toggleSvg"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g transform="matrix(1,0,0,1,-419.5,-274.131)">
                              <g id="arrow_rocket">
                                 <path
                                    id="top"
                                    d="M420,274.631L450,274.631C450,274.631 459.044,284.599 450,284.599C440.956,284.599 420,284.646 420,284.646L430.014,274.631"
                                 />
                                 <g transform="matrix(1,-1.22465e-16,-1.22465e-16,-1,0,569.277)">
                                    <path
                                       id="bottom"
                                       d="M420,274.631L450,274.631C450,274.631 459.044,284.599 450,284.599C440.956,284.599 420,284.646 420,284.646L430.014,274.631"
                                    />
                                 </g>
                                 <g transform="matrix(1,0,0,1,0,-0.0234189)">
                                    <path id="middle" d="M420,284.646L450,284.646" />
                                 </g>
                              </g>
                           </g>
                        </svg>

                     </button>
                  </div>
                  <div className="headermenu-cnt ml-lg-4">
                     <div className="header-menucntOne d-none d-lg-flex">
                        <div className="casinosports-box">
                           <Link to="/" class={isActive ? "" : "active"} onClick={() => { setIsActive(false); navigate("/") }}>
                              <div className="casino-grid casino-a">
                                 <div className="d-flex"><img src={casino} alt="" className="img-fluid" /> </div>
                                 <div className="ml-2">
                                    <h5>{t("Casino")}</h5>
                                 </div>
                              </div>
                           </Link>
                           <Link to="/comingsoon" class={isActive ? "active" : ""} onClick={() => { setIsActive(true); navigate("/comingsoon") }}>
                              <div className="casino-grid sports-a">
                                 <div className="d-flex"><img src={sports} alt="" className="img-fluid" /> </div>
                                 <div className="ml-2">
                                    <h5>{t("Sports")}</h5>
                                 </div>
                              </div>
                           </Link>
                        </div>
                        <div className="header-search ml-3">
                           <input type="text" name="" id="" value={searchText} onChange={(event) => getSearchFunction(event)} onFocus={() => setSearchIsActive(true)} placeholder={`${t('Game Name')} | ${t('Provider')} | ${t('Category Tag')} `} />
                           {
                              searchIsActive ?
                                 <a><span className="searchGames_CloseIcon" onClick={clearSearch} >X</span></a>
                                 :
                                 <a>
                                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                       <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9899 0C10.7622 0 13.8307 2.95111 13.8307 6.57919C13.8307 8.2909 13.1476 9.85208 12.03 11.0238L14.2292 13.1345C14.4351 13.3325 14.4358 13.6527 14.2299 13.8507C14.1274 13.9507 13.9918 14 13.8569 14C13.7228 14 13.5879 13.9507 13.4846 13.852L11.2588 11.7173C10.0879 12.6191 8.60327 13.1591 6.9899 13.1591C3.21758 13.1591 0.148438 10.2073 0.148438 6.57919C0.148438 2.95111 3.21758 0 6.9899 0ZM6.9899 1.01343C3.79853 1.01343 1.20216 3.50985 1.20216 6.57919C1.20216 9.64853 3.79853 12.1456 6.9899 12.1456C10.1806 12.1456 12.7769 9.64853 12.7769 6.57919C12.7769 3.50985 10.1806 1.01343 6.9899 1.01343Z" fill="white" />
                                    </svg>
                                 </a>
                           }
                        </div>
                     </div>

                     <div className="header-menucntTwo">
                        {
                           userToken === "" ||
                              userToken === undefined ||
                              userToken === null ?

                              <div className="loginreg-menu ml-2">
                                 <a className="login-menu" style={{ cursor: "pointer" }} onClick={togglePopRegister}>{t("Register")}</a>
                                 <a className="reg-menu px-2" style={{ cursor: "pointer" }} onClick={togglePopLogin}>{t("Login")}</a>
                              </div>
                              :
                              <div className="header-InrMenu">

                                 <div className="depositbtn_rn">
                                    <button className="btn btn-primary_rn grBtn" onClick={() => navigate('/deposit')}>{t("Deposit")}</button>
                                 </div>


                                 <div className="header-InrMenu">
                                    <div className="menuwallet-value">
                                       <div className="coinselect">
                                          <div className="form-group m-0">
                                             <select className="form-control" style={{ cursor: "pointer" }} id="exampleFormControlSelect1" onChange={(e) => getCurrency(e.target.value)}>
                                                <option value={selectCurrency?.cid}><label>{selectCurrency?.symbol}</label>{selectCurrency?.originalBal?.toFixed(2)}</option>
                                                {
                                                   selectedCurrency?.map((temp, index) =>
                                                      selectCurrency?.cid === temp?.cid ? null :

                                                         <option key={index} value={temp?.cid}><label>{temp?.symbol}</label>  {temp?.originalBal.toFixed(2)}</option>
                                                   )
                                                }
                                             </select>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 {/* </div> */}

                                 <div className="user-profile">
                                    <div className="dropdown">
                                       <SkeletonTheme baseColor="#444" height="34px" width="34px" borderRadius="18px" highlightColor="#fff" >
                                          {profile ? (
                                             <button
                                                className="dropdown-toggle"
                                                type="button"
                                                data-toggle="dropdown"
                                                aria-expanded="false"
                                             >
                                                <img
                                                   src={profile}
                                                   style={{ height: "34px", width: "34px", borderRadius: "18px" }}
                                                   id="userImg"
                                                   alt=""
                                                   className="img-fluid"
                                                />

                                             </button>
                                          ) : (<Skeleton />)}
                                       </SkeletonTheme>
                                       <div className="dropdown-menu">
                                          <Link className="dropdown-item" to="/myprofile">
                                             {t("Profile")}
                                          </Link>
                                          <Link className="dropdown-item" to="/kyc">
                                             {t("KYC")}
                                          </Link>
                                          <Link className="dropdown-item" to="/security">
                                             {t("Settings")}
                                          </Link>
                                          <Link
                                             className="dropdown-item"
                                             to="#"
                                             style={{ cursor: "pointer" }}
                                             onClick={logoutUser}
                                          >
                                             {t("Logout")}
                                          </Link>
                                       </div>
                                    </div>
                                 </div>
                              </div>

                        }
                     </div>
                  </div>
               </div>
            </div>

            <div className="newheader-main">
               <div className="newheader-cnt">
                  <button className="menubtn newsvgmenu" onClick={sideMenu}>
                     <div>
                        <svg
                           viewBox="0 0 36 34"
                           id="toggleSvg"
                           xmlns="http://www.w3.org/2000/svg"
                        >
                           <g transform="matrix(1,0,0,1,-419.5,-274.131)">
                              <g id="arrow_rocket">
                                 <path
                                    id="top"
                                    d="M420,274.631L450,274.631C450,274.631 459.044,284.599 450,284.599C440.956,284.599 420,284.646 420,284.646L430.014,274.631"
                                 />
                                 <g transform="matrix(1,-1.22465e-16,-1.22465e-16,-1,0,569.277)">
                                    <path
                                       id="bottom"
                                       d="M420,274.631L450,274.631C450,274.631 459.044,284.599 450,284.599C440.956,284.599 420,284.646 420,284.646L430.014,274.631"
                                    />
                                 </g>
                                 <g transform="matrix(1,0,0,1,0,-0.0234189)">
                                    <path id="middle" d="M420,284.646L450,284.646" />
                                 </g>
                              </g>
                           </g>
                        </svg>
                     </div>
                     <div>
                        <h5>Menu</h5>
                     </div>
                  </button>
                  <button onClick={() => navigate('/comingsoon')}>
                     <div><img src={liveCasinoImg} alt="" className="img-fluid" /></div>
                     <div>
                        <h5>{t('Live Casino')}</h5>
                     </div>
                  </button>
                  <button onClick={() => navigate('/')}>
                     <div><img src={casinonew} alt="" className="img-fluid" /></div>
                     <div>
                        <h5>{t('Casino')} </h5>
                     </div>
                  </button>
                  <button onClick={() => navigate('/comingsoon')}>
                     <div><img src={sports} alt="" className="img-fluid" /></div>
                     <div>
                        <h5>{t('Sports')}</h5>
                     </div>
                  </button>
               </div>
            </div>


         </header>


         {/* Forget Modal */}







         {/* Reset Modal */}


         <Modal
            isOpen={modal3}
            toggle={togglePopReset}
            className="signin_pop_total"
            backdrop="static"
         >
            <ModalBody className="p-0">
               <div className="row no-gutters r_hig">
                  <div className="col-md-6">
                     <div className="sisp text-center">
                        <h2>{t("Welcome to Rico Jogos")}</h2>
                        <div>
                           <img
                              src={NoThemeImg}
                              style={{ height: "50px", width: "240px" }}
                              id="appFavicon1"
                              alt=""
                           />
                        </div>
                     </div>
                  </div>
                  <div className="col-md-6">
                     <form onSubmit={handleSubmit3(onSubmit3)}>
                        <div className="rig_cd_po">
                           <div className="text-right">
                              <Link to="#" onClick={togglePopLogin}>
                                 <img src={circle} alt="" />
                              </Link>
                           </div>
                           <div className="mb-4">
                              <h2>{t("Reset Password")}</h2>
                           </div>
                           <div className="form-group nd_cm_in">
                              <input
                                 type={passwordType}
                                 name="password"
                                 autoComplete="off"
                                 className="form-control"
                                 {...register3("password", { required: true })}
                                 placeholder={t("Enter the Password")}
                              />
                              <a
                                 className="kannu-ko"
                                 style={{ cursor: "pointer" }}
                                 href="#"
                                 onClick={(e) => showVisibilitypwd(e)}
                              >
                                 {" "}
                                 <img src={lgkan} alt="" />
                              </a>
                           </div>
                           {errors3.password && (
                              <span className="text-danger">{errors3.password.message}</span>
                           )}
                           <div className="form-group nd_cm_in nd_cm_in_2 mb-2">
                              <input
                                 type={confirmpasswordType}
                                 className="form-control"
                                 autoComplete="off"
                                 {...register3("confirm_password", { required: true })}
                                 placeholder="Re-type Password"
                              />
                              <a
                                 className="kannu-ko"
                                 style={{ cursor: "pointer" }}
                                 href="#"
                                 onClick={(e) => showVisibilitycpwd(e)}
                              >
                                 {" "}
                                 <img src={lgkan} alt="" />
                              </a>
                           </div>
                           {errors3.confirm_password && (
                              <span className="text-danger">
                                 {errors3.confirm_password.message}
                              </span>
                           )}
                           <button className="btn" type="submit">
                              {t("Reset Password")}
                           </button>
                        </div>
                     </form>
                  </div>
               </div>
            </ModalBody>
         </Modal>


         {/*  Login Modal */}


         <Modal
            isOpen={modal}
            toggle={togglePopLogin}
            className="signin_pop_total"
            autoFocus={false}
         >
            <ModalBody className="p-0">
               <div className="row no-gutters r_hig">
                  <div className="col-md-6">

                     <SkeletonTheme baseColor="#444" height="110px" width="110px" highlightColor="#fff" borderRadius="80px">

                        <div className="sisp text-center">
                           <h2>  {t("Welcome to Rico Jogos")} </h2>
                           <div>
                              {NoThemeImg ? (
                                 <img
                                    src={NoThemeImg}
                                    style={{ height: "50px", width: "240px" }}
                                    alt=""
                                 />
                              ) : (<Skeleton />)}
                           </div>
                           <div>
                              <img src={lgroc} alt="" />
                           </div>
                        </div>
                     </SkeletonTheme>
                  </div>
                  <div className="col-md-6">
                     <form onSubmit={handleSubmit1(onSubmit1)} autoComplete="off">
                        <div className="rig_cd_po">
                           <div className="text-right">
                              <Link to="#" onClick={togglePopLogin}>
                                 <img src={circle} alt="" />
                              </Link>
                           </div>
                           <div className="mb-4">
                              <h2>{t("Sign in")}</h2>
                           </div>
                           <div className="form-group nd_cm_in">
                              <input
                                 type="email"
                                 name="email"
                                 autoFocus={false}
                                 className="form-control"
                                 {...register1("email", { required: true })}
                                 placeholder={t("Enter Email Address")}
                              />
                              {errors1.email && (
                                 <span className="text-danger">{errors1.email.message}</span>
                              )}
                           </div>
                           <div className="mb-2">
                              <div className="form-group nd_cm_in nd_cm_in_2 mb-0">
                                 <input
                                    type={passwordType}
                                    className="form-control"
                                    {...register1("password", { required: true })}
                                    placeholder={t("Enter Password")}
                                 />
                                 <a
                                    className="kannu-ko"
                                    href="#"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => showVisibilitypwd(e)}
                                 >
                                    {" "}
                                    <img src={lgkan} alt="" />
                                 </a>
                              </div>
                              {errors1.password && (
                                 <span className="text-danger">
                                    {errors1.password.message}
                                 </span>
                              )}
                           </div>

                           <div className="fr_eet text-right">
                              <Link to="#" onClick={togglePopForgot}>
                                 {t("Forgot password")}  ?
                              </Link>
                           </div>
                           <button className="btn" type="submit">
                              {t("Signin")}
                           </button>
                           <p>
                              {t("Dont have an account")} ?
                              <Link to="#" onClick={togglePopRegister}>
                                 {" "}
                                 {t("Create Now")}
                              </Link>
                           </p>
                           <h3>{t("OR")}</h3>
                           <p> {t("Log in directly with")}</p>
                           <div className="d-flex align-items-center justify-content-center ic_le">
                              <Link to="#">
                                 <GoogleLogin
                                    clientId={googleId}
                                    buttonText=""
                                    onSuccess={responseGoogle}
                                    onFailure={responseGooglefailure}
                                    cookiePolicy={"single_host_origin"}
                                    render={(renderProps) => (
                                       <div onClick={renderProps.onClick}>
                                          <img src={lggr1} alt="gmail" />
                                       </div>
                                    )}
                                 />

                              </Link>

                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </ModalBody>
         </Modal>

         {/* ======= Forget Modal =========== */}

         <Modal
            isOpen={modal1}
            toggle={togglePopForgot}
            className="signin_pop_total"
            backdrop="static"
            autoFocus={false}
         >
            <ModalBody className="p-0">
               {/* yes */}
               <div className="row no-gutters r_hig">
                  <div className="col-md-6">
                     <div className="sisp text-center">
                        <h2>{t("Welcome to Rico Jogos")}</h2>
                        <SkeletonTheme baseColor="#444" height="148px" width="138px" highlightColor="#fff" borderRadius="80px">
                           <div>
                              {NoThemeImg ? (
                                 <img
                                    src={NoThemeImg}
                                    style={{ height: "50px", width: "250px" }}
                                    id="appFavicon1"
                                    alt=""
                                 />
                              ) : (<Skeleton />)}
                           </div>
                        </SkeletonTheme>

                        <div>
                           <img src={lgroc} alt="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-md-6">
                     <form onSubmit={handleSubmit2(onSubmit2)} autoComplete="off" >
                        <div className="rig_cd_po">
                           <div className="text-right">
                              <Link to="#" onClick={togglePopForgot}>
                                 <img src={circle} alt="" />
                              </Link>
                           </div>
                           <div className="mb-4">
                              <h2>{t("Forgot password")}</h2>
                           </div>
                           <div className="form-group nd_cm_in">
                              <input
                                 type="email"
                                 name="email"
                                 autoFocus={false}

                                 className="form-control"
                                 {...register2("email", { required: true })}
                                 placeholder={t("Email Address")}
                              />
                              {errors2.email && (
                                 <span className="text-danger">{errors2.email.message}</span>
                              )}
                           </div>
                           <div className="mb-5">
                              <button className="btn" type="submit">
                                 {t("Forgot password")}
                              </button>
                           </div>
                           <p>
                              {t("Already have an account")} ? {" "}
                              <Link to="#" onClick={togglePopLogin}>
                                 {" "}
                                 {t("Sign in")}
                              </Link>
                           </p>
                           <h3>{t("OR")}</h3>
                           <p>{t("Log in directly with")}</p>
                           <div className="d-flex align-items-center justify-content-center ic_le">
                              <Link to="">
                                 <GoogleLogin
                                    clientId={googleId}
                                    buttonText=""
                                    onSuccess={responseGoogle}
                                    onFailure={responseGooglefailure}
                                    cookiePolicy={"single_host_origin"}
                                    render={(renderProps) => (
                                       <div onClick={renderProps.onClick}>
                                          <img src={lggr1} alt="gmail" />
                                       </div>
                                    )}
                                 />

                              </Link>

                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </ModalBody>
         </Modal>


         {/* ==== TFA LOGIN */}


         <Modal
            isOpen={modal4}
            toggle={togglePopForgot}
            className="signin_pop_total"
            backdrop="static"
         >
            <ModalBody className="p-0">
               <div className="row no-gutters r_hig">
                  <div className="col-md-6">
                     <div className="sisp text-center">
                        <h2>{t("Welcome to Rico Jogos")}</h2>
                        <div>
                           <img
                              src={NoThemeImg}
                              style={{ height: "50px", width: "240px" }}
                              id="appFavicon1"
                              alt=""
                           />
                        </div>
                        <div>
                           <img src={lgroc} alt="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-md-6">
                     <form>
                        <div className="rig_cd_po">
                           <div className="text-right">
                              <Link to="#" onClick={togglePopForgot}>
                                 <img src={circle} alt="" />
                              </Link>
                           </div>
                           <div className="mb-4">
                              <h2>{t("Tfalogin")}</h2>
                           </div>
                           <div className="form-group nd_cm_in">
                              <NumericFormat
                                 className="form-control"
                                 allowLeadingZeros
                                 placeholder={t('Enter the TFA Code')}
                                 onChange={(e) => setTfacode(e.target.value)}
                                 value={tfaCode}
                              />
                           </div>
                           <div className="mb-5">
                              <button className="btn" onClick={(e) => tfaValidate(e)}>
                                 {t("Submit")}
                              </button>
                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </ModalBody>
         </Modal>


         {/* ========= Register Modal========== */}

         <Modal
            isOpen={modal2}
            toggle={togglePopRegister}
            className="signin_pop_total"
            autoFocus={false}

         >
            <ModalBody className="p-0">
               <div className="row no-gutters r_hig">
                  <div className="col-md-6">
                     <div className="sisp text-center">
                        <h2>{t("Welcome to Rico Jogos")}</h2>
                        <div>
                           <img
                              src={NoThemeImg}
                              style={{ height: "50px", width: "240px" }}
                              id="appFavicon1"
                              alt=""
                           />
                        </div>
                        <div>
                           <img src={lgroc} alt="" />
                        </div>
                     </div>
                  </div>
                  <div className="col-md-6">
                     <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="rig_cd_po">
                           <div className="text-right">
                              <Link to="#" onClick={togglePopRegister}>
                                 <img src={circle} alt="" />
                              </Link>
                           </div>
                           <div className="mb-4">
                              <h2>{t("Register")}</h2>
                           </div>

                           <div className="form-group nd_cm_in">



                              <PatternFormat
                                 className="form-control"
                                 allowLeadingZeros
                                 placeholder={t("CPF Number")}
                                 format="###.###.###-##"
                                 onChange={(event) => setCpfNumber(event.target.value)}
                                 name="cpf_No"
                                 value={cpfNumber}
                                 autoFocus={cpfFocus}
                              />
                           </div>
                           <div className="form-group nd_cm_in">
                              <input
                                 type="text"
                                 name="username"
                                 autoComplete="off"
                                 className="form-control"
                                 {...register("username", {
                                    required: true,
                                    maxLength: 20,
                                 })}
                                 placeholder={t("User name")}
                              />
                              {errors.username && (
                                 <span className="text-danger">{errors.username.message}</span>
                              )}
                           </div>

                           <div className="form-group nd_cm_in">
                              <input
                                 type="text"
                                 name="fullName"
                                 autoComplete="off"
                                 className="form-control"
                                 {...register("fullName", {
                                    required: true,
                                    maxLength: 20,
                                 })}
                                 placeholder={t("EnterYourName")}
                              />
                              {errors.fullName && (
                                 <span className="text-danger">{errors.fullName.message}</span>
                              )}
                           </div>

                           <div className="form-group nd_cm_in">
                              <input
                                 type="email"
                                 name="email_address"
                                 autoComplete="off"
                                 className="form-control"
                                 {...register("email_address", {
                                    required: true,
                                    maxLength: 20,
                                 })}
                                 placeholder={t("Email Address")}
                              />
                              {errors.email_address && (
                                 <span className="text-danger">
                                    {errors.email_address.message}
                                 </span>
                              )}
                           </div>

                           <div className="form-group nd_cm_in">
                              <input
                                 type="text"
                                 name="phoneNumber"
                                 autoComplete="off"
                                 className="form-control"
                                 {...register("phoneNumber", {
                                    required: true,
                                 })}
                                 placeholder={t("Phone Number")}
                              />
                              {errors.phoneNumber && (
                                 <span className="text-danger">
                                    {errors.phoneNumber.message}
                                 </span>
                              )}
                           </div>


                           <div className="mb-3">
                              <div className="form-group nd_cm_in nd_cm_in_2 mb-0">
                                 <input
                                    type={passwordType}
                                    name="password"

                                    autoComplete="off"
                                    className="form-control"
                                    {...register("password", {
                                       required: true,
                                       maxLength: 20,
                                    })}
                                    placeholder={t("Password")}
                                 />
                                 <a
                                    className="kannu-ko"
                                    href="#"
                                    style={{ cursor: "pointer" }}
                                    onClick={(e) => showVisibilitypwd(e)}
                                 >
                                    {" "}
                                    <img src={lgkan} alt="" />{" "}
                                 </a>
                              </div>
                              {errors.password && (
                                 <span className="text-danger">{errors.password.message}</span>
                              )}
                           </div>
                           <div className="form-group nd_cm_in nd_cm_in_2 ">
                              <input
                                 type="password"
                                 name="confirm_password"
                                 autoComplete="off"
                                 className="form-control"
                                 {...register("confirm_password", {
                                    required: true,
                                    maxLength: 20,
                                 })}
                                 placeholder={t("Confirm Password")}
                              />
                              {errors.confirm_password && (
                                 <span className="text-danger">
                                    {errors.confirm_password.message}
                                 </span>
                              )}

                           </div>
                           <br />

                           <ReCAPTCHA
                              name="g-recaptcha-response"
                              sitekey="6LeA4iAmAAAAAFuX6N0QYwEtJj0QbjslF8YUYwEO"
                              onChange={(value) => {
                                 setFarmCaptcha(value);
                                 setFarmErrCaptcha("");
                              }}
                           />

                           <br />

                           <div>
                              <label className="cus_ch">
                                 {t("aggrement")}
                                 <input
                                    type="checkbox"
                                    name="terms"
                                    {...register("terms")}
                                 />
                                 <span className="checkmark"></span>
                                 {errors.terms && (
                                    <span className="text-danger">{errors.terms.message}</span>
                                 )}
                              </label>
                           </div>
                           <button className="btn" type="submit">
                              {t("Sign up")}
                           </button>
                           <p>
                              {t("Already have an account")} ? {" "}
                              <Link to="#" onClick={togglePopLogin}>
                                 {" "}
                                 {t("Sign in")}
                              </Link>
                           </p>
                           <h3>{t("OR")}</h3>
                           <p>{t("Log in directly with")}</p>
                           <div className="d-flex align-items-center justify-content-center ic_le">
                              <Link to="">
                                 <GoogleLogin
                                    clientId={googleId}
                                    buttonText=""
                                    onSuccess={responseGoogle}
                                    onFailure={responseGooglefailure}
                                    cookiePolicy={"single_host_origin"}
                                    render={(renderProps) => (
                                       <div onClick={renderProps.onClick}>
                                          <img src={lggr1} alt="gmail" />
                                       </div>
                                    )}
                                 />

                              </Link>

                           </div>
                        </div>
                     </form>
                  </div>
               </div>
            </ModalBody>
         </Modal>
      </Fragment >
   );
}

export default Header;

